<ngb-alert type="danger" [dismissible]="false" class="d-flex items-center mt-2"
  ><i class="material-icons me-1">info</i>{{ noticeText }}</ngb-alert
>
